<template>
  <tools-host />
</template>
<script>
import ToolsHost from '@/components/tools/ToolsHost.vue'
export default {
  name: 'ToolsView',
  components: {
    ToolsHost
  }
}
</script>
<style lang="scss" scoped></style>
